const districtCoords = require("./districtCoords");

export const districtMap = () => {

    window.initMap = () => {

        let el = document.querySelector("[data-map='districts']");

        if (!el) {
            return;
        }

        let spans = document.querySelectorAll(".districts nav span");
        let buttons = document.querySelectorAll(".districts ul button");
        let header = document.querySelector(".districts header");
        let articles = document.querySelectorAll(".districts article");
        let toggle = document.querySelector(".districts__toggle");
        let dropdown = document.querySelector(".districts__dropdown");

        const gmap = new google.maps.Map(el, {
            center: new google.maps.LatLng(52.6293, 1.2979),
            zoom: 15,
            streetViewControl: false,
            disableDefaultUI: true,
            zoomControl: true,
            gestureHandling: 'cooperative'
        });

        let districts = {
            'business-district': { coords: districtCoords.businessCoords, fill: '#385849', text: 'white', centerLat: 52.6239, centerLng: 1.2946},
            'castle-and-marketplace': { coords: districtCoords.castleCoords, fill: '#37153b', text: 'white', centerLat: 52.6280, centerLng: 1.2939},
            'cathedral-quarter': { coords: districtCoords.cathedralCoords, fill: '#3c84c5', text: 'white', centerLat: 52.6319, centerLng: 1.3027},
            'chapelfield': { coords: districtCoords.chapelfieldCoords, fill: '#d86e4d', text: 'white', centerLat: 52.6268, centerLng: 1.2891},
            'creative-quarter': { coords: districtCoords.creativeCoords, fill: '#f5cb53', text: 'black', centerLat: 52.6331, centerLng: 1.2942},
            'king-street-quarter': { coords: districtCoords.kingsCoords, fill: '#90353c', text: 'white', centerLat: 52.6250, centerLng: 1.300},
            'norwich-lanes': { coords: districtCoords.lanesCoords, fill: '#edc1b8', text: 'black', centerLat: 52.6307, centerLng: 1.2891},
            'riverside': { coords: districtCoords.riversideCoords, fill: '#b5cfcc', text: 'black', centerLat: 52.6238, centerLng: 1.3073}
        }

        for (let district in districts) if (districts.hasOwnProperty(district)) {
            let i = districts[district]
            let polygonOptions = {
                paths: i.coords,
                strokeColor: i.fill,
                strokeOpacity: 1,
                strokeWeight: 3,
                fillColor: i.fill,
                fillOpacity: 0.6
            };
            i.instance = new google.maps.Polygon(polygonOptions);
        }

        document.addEventListener('click', function (event) {

            if (event.target.matches('.districts__toggle')) {
                if (event.target.getAttribute('aria-expanded') === 'false') {
                    event.target.setAttribute('aria-expanded', 'true');
                    dropdown.setAttribute('aria-hidden', 'false');
                } else {
                    event.target.setAttribute('aria-expanded', 'false');
                    dropdown.setAttribute('aria-hidden', 'true');
                }
            }

            if (event.target.matches('.district__select')) {
                let selected = event.target.getAttribute('data-district');
                updateDistrict(selected);
                toggle.setAttribute('aria-expanded', 'false');
                dropdown.setAttribute('aria-hidden', 'true');
            }

        });

        const updateDistrict = (selected) => {

            for (let district in districts) if (districts.hasOwnProperty(district)) {
                let i = districts[district]
                i.instance.setMap(null);
            }

            districts[selected].instance.setMap(gmap);
            let myLatlng = new google.maps.LatLng(districts[selected].centerLat, districts[selected].centerLng);
            gmap.panTo(myLatlng);

            header.style.backgroundColor = districts[selected].fill
            header.style.color = districts[selected].text

            for (let i = 0; i < spans.length; ++i) {
                spans[i].setAttribute('aria-hidden', true);

                if (spans[i].getAttribute('data-district') === selected) {
                    spans[i].setAttribute('aria-hidden', false);
                }
            }

            for (let i = 0; i < buttons.length; ++i) {
                buttons[i].setAttribute('aria-expanded', false);
                buttons[i].style.backgroundColor = 'transparent'

                if (buttons[i].getAttribute('data-district') === selected) {
                    buttons[i].setAttribute('aria-expanded', true);
                    buttons[i].style.backgroundColor = districts[selected].fill
                }
            }

            for (let i = 0; i < articles.length; ++i) {
                articles[i].style.backgroundColor = districts[selected].fill
                articles[i].style.color = districts[selected].text
                articles[i].setAttribute('aria-hidden', true);

                if (articles[i].getAttribute('data-district') === selected) {
                    articles[i].setAttribute('aria-hidden', false);
                }
            }
        }

        let initial = 'business-district';
        updateDistrict(initial);

    }

}
